// Importing React library for creating React components
import React, { useEffect } from "react";
import "./Flag.css";

// Importing the colors configuration from an external file
import { colors } from "../config";
import pronounComponents from "../pronouns.js";

// Setting the width and height of the flag
const width = 40;
const height = 24;

// Flag component with an optional triangle parameter for additional design
// white and red/purple are default values
//grey_2 for poly is the default value for non-poly
const Flag = ({
  triangle = ["white"],
  hStripeColors = ["white"],
  vStripeColors = ["white"],
  chevron = ["white"],
  pronouns = ["na"],
  poly = ["grey_2"],
  hoverPronouns,
  hoverPoly,
  hoverTriangle,
  hoverChevron,
  hoverEmotional,
  hoverPhysical,
  hoverBoth,
  resetHover,
}) => {
  //function to toggle opacity of all other elements
  //original is element you don't want to change opacity of.
  function opacityAdd(original) {
    const flagElements = [
      document.getElementById("pronounsImage"),
      document.getElementById("poly"),
      document.getElementById("triangle"),
      document.getElementById("chevron"),
      document.getElementById("hStripes"),
      document.getElementById("vStripes"),
    ];
    flagElements.map((item, index) => {
      if (item !== original) {
        try {
          item.classList.add("opacity-hovered");
        } catch (e) {}
      }
    });
  }
  function opacityAddMultiple(original, original2) {
    const flagElements = [
      document.getElementById("pronounsImage"),
      document.getElementById("poly"),
      document.getElementById("triangle"),
      document.getElementById("chevron"),
      document.getElementById("hStripes"),
      document.getElementById("vStripes"),
    ];
    flagElements.map((item, index) => {
      if (item !== original && item !== original2) {
        try {
          item.classList.add("opacity-hovered");
        } catch (e) {}
      }
    });
  }

  function opacityRemove(original) {
    const flagElements = [
      document.getElementById("pronounsImage"),
      document.getElementById("poly"),
      document.getElementById("triangle"),
      document.getElementById("chevron"),
      document.getElementById("hStripes"),
      document.getElementById("vStripes"),
    ];
    flagElements.map((item, index) => {
      if (item !== original) {
        try {
          item.classList.remove("opacity-hovered");
        } catch (e) {}
      }
    });
  }

  //hovering pronouns image
  useEffect(() => {
    try {
      const pronounsImage = document.getElementById("pronounsImage");

      const handleMouseEnter = () => {
        hoverPronouns();
        opacityAdd(pronounsImage);
      };
      const handleMouseLeave = () => {
        // Handle mouse leave actions if needed
        // For example, you can console.log or perform other actions
        resetHover();
        opacityRemove(pronounsImage);
      };

      pronounsImage.addEventListener("mouseenter", handleMouseEnter);
      pronounsImage.addEventListener("mouseleave", handleMouseLeave);

      // Cleanup function to remove the event listener when the component unmounts
      return () => {
        pronounsImage.removeEventListener("mouseenter", handleMouseEnter);
        pronounsImage.removeEventListener("mouseleave", handleMouseLeave);
      };
    } catch (e) {}
  }, [hoverPronouns, resetHover]);

  //hovering poly symbol
  useEffect(() => {
    try {
      const polyImage = document.getElementById("poly");

      const handleMouseEnter = () => {
        hoverPoly();
        opacityAdd(polyImage);
      };
      const handleMouseLeave = () => {
        // Handle mouse leave actions if needed
        // For example, you can console.log or perform other actions
        resetHover();
        opacityRemove(polyImage);
      };

      polyImage.addEventListener("mouseenter", handleMouseEnter);
      polyImage.addEventListener("mouseleave", handleMouseLeave);

      // Cleanup function to remove the event listener when the component unmounts
      return () => {
        polyImage.removeEventListener("mouseenter", handleMouseEnter);
        polyImage.removeEventListener("mouseleave", handleMouseEnter);
      };
    } catch (e) {}
  }, [hoverPoly, resetHover]);

  //hovering triangle
  useEffect(() => {
    const triangle = document.getElementById("triangle");

    const handleMouseEnter = () => {
      hoverTriangle();
      opacityAdd(triangle);
    };
    const handleMouseLeave = () => {
      // Handle mouse leave actions if needed
      // For example, you can console.log or perform other actions
      resetHover();
      opacityRemove(triangle);
    };

    triangle.addEventListener("mouseenter", handleMouseEnter);
    triangle.addEventListener("mouseleave", handleMouseLeave);

    // Cleanup function to remove the event listener when the component unmounts
    return () => {
      triangle.removeEventListener("mouseenter", handleMouseEnter);
      triangle.removeEventListener("mouseleave", handleMouseEnter);
    };
  }, [hoverTriangle, resetHover]);

  //hovering chevron
  useEffect(() => {
    const chevron = document.getElementById("chevron");

    const handleMouseEnter = () => {
      hoverChevron();
      opacityAdd(chevron);
    };
    const handleMouseLeave = () => {
      // Handle mouse leave actions if needed
      // For example, you can console.log or perform other actions
      resetHover();
      opacityRemove(chevron);
    };

    chevron.addEventListener("mouseenter", handleMouseEnter);
    chevron.addEventListener("mouseleave", handleMouseLeave);

    // Cleanup function to remove the event listener when the component unmounts
    return () => {
      chevron.removeEventListener("mouseenter", handleMouseEnter);
      chevron.removeEventListener("mouseleave", handleMouseEnter);
    };
  }, [hoverChevron, resetHover]);

  //hovering vertical (emotional) stripes
  useEffect(() => {
    const vStripes = document.getElementById("vStripes");

    const handleMouseEnter = () => {
      hoverEmotional();
      opacityAdd(vStripes);
    };
    const handleMouseLeave = () => {
      // Handle mouse leave actions if needed
      // For example, you can console.log or perform other actions
      resetHover();
      opacityRemove(vStripes);
    };

    vStripes.addEventListener("mouseenter", handleMouseEnter);
    vStripes.addEventListener("mouseleave", handleMouseLeave);

    // Cleanup function to remove the event listener when the component unmounts
    return () => {
      vStripes.removeEventListener("mouseenter", handleMouseEnter);
      vStripes.removeEventListener("mouseleave", handleMouseEnter);
    };
  }, [hoverEmotional, resetHover]);

  //hovering horizontal (physical) stripes
  useEffect(() => {
    const hStripes = document.getElementById("hStripes");

    const handleMouseEnter = () => {
      hoverPhysical();
      opacityAdd(hStripes);
    };
    const handleMouseLeave = () => {
      // Handle mouse leave actions if needed
      // For example, you can console.log or perform other actions
      resetHover();
      opacityRemove(hStripes);
    };

    hStripes.addEventListener("mouseenter", handleMouseEnter);
    hStripes.addEventListener("mouseleave", handleMouseLeave);

    // Cleanup function to remove the event listener when the component unmounts
    return () => {
      hStripes.removeEventListener("mouseenter", handleMouseEnter);
      hStripes.removeEventListener("mouseleave", handleMouseEnter);
    };
  }, [hoverPhysical, resetHover]);

  //TEXT HOVERS

  // document.getElementById("pronounsImage"),
  // document.getElementById("poly"),
  // document.getElementById("triangle"),
  // document.getElementById("chevron"),
  // document.getElementById("hStripes"),
  // document.getElementById("vStripes"),

  //text hover for sense of self
  useEffect(() => {
    try {
      const text = document.getElementById("self");
      const self = document.getElementById("triangle");

      const handleMouseEnter = () => {
        opacityAdd(self);
        hoverTriangle();
      };
      const handleMouseLeave = () => {
        // Handle mouse leave actions if needed
        // For example, you can console.log or perform other actions
        opacityRemove(self);
        resetHover();
      };

      text.addEventListener("mouseenter", handleMouseEnter);
      text.addEventListener("mouseleave", handleMouseLeave);

      // Cleanup function to remove the event listener when the component unmounts
      return () => {
        text.removeEventListener("mouseenter", handleMouseEnter);
        text.removeEventListener("mouseleave", handleMouseLeave);
      };
    } catch (e) {}
  }, [hoverTriangle, resetHover]);

  //text hover for sense of body
  useEffect(() => {
    try {
      const text = document.getElementById("body");
      const body = document.getElementById("chevron");

      const handleMouseEnter = () => {
        opacityAdd(body);
        hoverChevron();
      };
      const handleMouseLeave = () => {
        // Handle mouse leave actions if needed
        // For example, you can console.log or perform other actions
        opacityRemove(body);
        resetHover();
      };

      text.addEventListener("mouseenter", handleMouseEnter);
      text.addEventListener("mouseleave", handleMouseLeave);

      // Cleanup function to remove the event listener when the component unmounts
      return () => {
        text.removeEventListener("mouseenter", handleMouseEnter);
        text.removeEventListener("mouseleave", handleMouseLeave);
      };
    } catch (e) {}
  }, [hoverChevron, resetHover]);

  //text hover for pronouns
  useEffect(() => {
    try {
      const text = document.getElementById("pronouns");
      const pronounsImage = document.getElementById("pronounsImage");

      const handleMouseEnter = () => {
        opacityAdd(pronounsImage);
        hoverPronouns();
      };
      const handleMouseLeave = () => {
        // Handle mouse leave actions if needed
        // For example, you can console.log or perform other actions
        opacityRemove(pronounsImage);
        resetHover();
      };

      text.addEventListener("mouseenter", handleMouseEnter);
      text.addEventListener("mouseleave", handleMouseLeave);

      // Cleanup function to remove the event listener when the component unmounts
      return () => {
        text.removeEventListener("mouseenter", handleMouseEnter);
        text.removeEventListener("mouseleave", handleMouseLeave);
      };
    } catch (e) {}
  }, [hoverPronouns, resetHover]);

  //text hover for poly heart
  useEffect(() => {
    try {
      const text = document.getElementById("polyamorous");
      const poly = document.getElementById("poly");

      const handleMouseEnter = () => {
        opacityAdd(poly);
        hoverPoly();
      };
      const handleMouseLeave = () => {
        // Handle mouse leave actions if needed
        // For example, you can console.log or perform other actions
        opacityRemove(poly);
        resetHover();
      };

      text.addEventListener("mouseenter", handleMouseEnter);
      text.addEventListener("mouseleave", handleMouseLeave);

      // Cleanup function to remove the event listener when the component unmounts
      return () => {
        text.removeEventListener("mouseenter", handleMouseEnter);
        text.removeEventListener("mouseleave", handleMouseLeave);
      };
    } catch (e) {}
  }, [hoverPoly, resetHover]);

  //text hover for physical attraction
  useEffect(() => {
    try {
      const text = document.getElementById("physical");
      const hStripes = document.getElementById("hStripes");

      const handleMouseEnter = () => {
        opacityAdd(hStripes);
        hoverPhysical();
      };
      const handleMouseLeave = () => {
        // Handle mouse leave actions if needed
        // For example, you can console.log or perform other actions
        opacityRemove(hStripes);
        resetHover();
      };

      text.addEventListener("mouseenter", handleMouseEnter);
      text.addEventListener("mouseleave", handleMouseLeave);

      // Cleanup function to remove the event listener when the component unmounts
      return () => {
        text.removeEventListener("mouseenter", handleMouseEnter);
        text.removeEventListener("mouseleave", handleMouseLeave);
      };
    } catch (e) {}
  }, [hoverPhysical, resetHover]);

  //text hover for emotional attraction
  useEffect(() => {
    try {
      const text = document.getElementById("emotional");
      const vStripes = document.getElementById("vStripes");

      const handleMouseEnter = () => {
        opacityAdd(vStripes);
        hoverEmotional();
      };
      const handleMouseLeave = () => {
        // Handle mouse leave actions if needed
        // For example, you can console.log or perform other actions
        opacityRemove(vStripes);
        resetHover();
      };

      text.addEventListener("mouseenter", handleMouseEnter);
      text.addEventListener("mouseleave", handleMouseLeave);

      // Cleanup function to remove the event listener when the component unmounts
      return () => {
        text.removeEventListener("mouseenter", handleMouseEnter);
        text.removeEventListener("mouseleave", handleMouseLeave);
      };
    } catch (e) {}
  }, [hoverEmotional, resetHover]);

  //text hover for both emotional/physical attraction
  useEffect(() => {
    try {
      const text = document.getElementById("experience");
      const text2 = document.getElementById("experience2");
      const text3 = document.getElementById("experience3");
      const text4 = document.getElementById("experience4");
      const vStripes = document.getElementById("vStripes");
      const hStripes = document.getElementById("hStripes");

      const handleMouseEnter = () => {
        opacityAddMultiple(vStripes, hStripes);
        hoverBoth();
      };
      const handleMouseLeave = () => {
        // Handle mouse leave actions if needed
        // For example, you can console.log or perform other actions
        opacityRemove(vStripes);
        opacityRemove(hStripes);
        resetHover();
      };

      text.addEventListener("mouseenter", handleMouseEnter);
      text.addEventListener("mouseleave", handleMouseLeave);
      text2.addEventListener("mouseenter", handleMouseEnter);
      text2.addEventListener("mouseleave", handleMouseLeave);
      text3.addEventListener("mouseenter", handleMouseEnter);
      text3.addEventListener("mouseleave", handleMouseLeave);
      text4.addEventListener("mouseenter", handleMouseEnter);
      text4.addEventListener("mouseleave", handleMouseLeave);

      // Cleanup function to remove the event listener when the component unmounts
      return () => {
        text.removeEventListener("mouseenter", handleMouseEnter);
        text.removeEventListener("mouseleave", handleMouseLeave);
        text2.removeEventListener("mouseenter", handleMouseEnter);
        text2.removeEventListener("mouseleave", handleMouseLeave);
        text3.removeEventListener("mouseenter", handleMouseEnter);
        text3.removeEventListener("mouseleave", handleMouseLeave);
        text4.removeEventListener("mouseenter", handleMouseEnter);
        text4.removeEventListener("mouseleave", handleMouseLeave);
      };
    } catch (e) {}
  }, [hoverBoth, resetHover]);

  // Generating horizontal stripes for the flag
  const hStripes = hStripeColors.map((color, i, s) => (
    <rect
      key={i}
      x={0}
      // Calculating the y position for each horizontal stripe
      y={(height * (3 / 5) * i) / s.length + height / 5}
      width={width}
      // Calculating the height of each horizontal stripe
      height={((height * (3 / 5)) / s.length + 0.1).toFixed(2)}
      // Filling the stripe with the corresponding color from the configuration
      fill={colors[color][2]}
    ></rect>
  ));

  // Generating vertical stripes for the flag
  const vStripes = vStripeColors.map((color, i, s) => (
    <React.Fragment key={i}>
      {/* Upper part of each vertical stripe */}
      <rect
        x={(width / s.length) * i}
        y={0}
        width={width / (s.length - 1 > 0 ? s.length : 1)}
        height={height / 5 + 0.05}
        fill={colors[color][3]}
      ></rect>
      {/* Lower part of each vertical stripe */}
      <rect
        x={(width / s.length) * i}
        y={((height * 2) / 5) * 2}
        width={width / (s.length - 1 > 0 ? s.length : 1)}
        height={height / 5}
        fill={colors[color][3]}
      ></rect>
    </React.Fragment>
  ));

  // Draws the triangle
  const leftTriangle = triangle.map((color, i) => {
    return (
      <React.Fragment key={i}>
        {/* <polygon points={`${0 - (i * (14 / (color.length - 1)))},0 ${0},${24 - (i * (10 / (color.length - 1)))} ${15 - (i * (12 / (color.length - 1)))},${12}`} fill={colors[color][0]}></polygon> */}

        <polygon
          points={`
    ${0 - i * (16 / triangle.length)} ${0},
    ${0} ${24 - i * (12 / triangle.length)},
    ${15 - i * (15 / triangle.length)} ${12}
  `}
          fill={colors[color][1]}
        ></polygon>
      </React.Fragment>
    );
  });

  //underneath pentagon, to disallow seeing stripes when triangle is lower opacity.
  const pentagonUnderneath = triangle.map((color, i) => {
    return (
      <React.Fragment key={i}>
        {/* <polygon points={`${0 - (i * (14 / (color.length - 1)))},0 ${0},${24 - (i * (10 / (color.length - 1)))} ${15 - (i * (12 / (color.length - 1)))},${12}`} fill={colors[color][0]}></polygon> */}

        <polygon
          points={`
    ${3.6 - i * (16 / (triangle.length - 0.5))} ${0},
    ${0 - i * (16 / (triangle.length - 0.5))} ${0},
    ${0} ${24 - i * (11 / (triangle.length - 0.5))},
    ${3.6} ${24 - i * (11 / (triangle.length - 0.5))},
    ${18.6 - i * (13 / (triangle.length - 0.6))} ${12}
  `}
          fill={colors["bg"][0]}
        ></polygon>
      </React.Fragment>
    );
  });
  //underneath triangle
  const triangleUnderneath = triangle.map((color, i) => {
    return (
      <React.Fragment key={i}>
        {/* <polygon points={`${0 - (i * (14 / (color.length - 1)))},0 ${0},${24 - (i * (10 / (color.length - 1)))} ${15 - (i * (12 / (color.length - 1)))},${12}`} fill={colors[color][0]}></polygon> */}

        <polygon
          points={`
    ${0 - i * (16 / (triangle.length - 0.5))} ${0},
    ${0} ${24 - i * (11 / (triangle.length - 0.5))},
    ${15 - i * (13 / (triangle.length - 0.6))} ${12}
  `}
          fill={colors["bg"][0]}
        ></polygon>
      </React.Fragment>
    );
  });

  // Draws the chevron
  const leftChevron = (color) => {
    if (color[0] === "intersex") {
      const diff = 0.7;

      return (
        <React.Fragment>
          {/* ${0}            ${0},
        ${0}            ${24},
        ${3.6}            ${24},
        ${18.6}           ${12},
        ${3.6}            ${0}`} */}
          <polygon
            points={`
          ${0}            ${0},
          ${0}            ${24},
          ${3.6}            ${24},
          ${18.6}           ${12},
          ${3.6}            ${0}`}
            fill={colors["purple"][0]}
          ></polygon>

          <polygon
            points={`
          ${0}                   ${0},
          ${0}                   ${24},
          ${3.3 - diff}            ${24},
          ${18.3 - diff}           ${12},
          ${3.3 - diff}            ${0}`}
            fill={colors["yellow"][0]}
          ></polygon>

          <polygon
            points={`
          ${0}                     ${0},
          ${0}                     ${24},
          ${3.3 - diff * 3}            ${24},
          ${18.3 - diff * 3}           ${12},
          ${3.3 - diff * 3}            ${0}`}
            fill={colors["purple"][0]}
          ></polygon>
        </React.Fragment>
      );
    }

    // Solid colour
    else {
      return (
        <React.Fragment>
          <polygon
            points={`
          ${0}            ${0},
          ${0}            ${24},
          ${3.6}            ${24},
          ${18.6}           ${12},
          ${3.6}            ${0}`}
            fill={colors[color[0]][0]}
          ></polygon>
        </React.Fragment>
      );
    }
  };

  const pronounSymbol = (selected) => {
    let symbol = null;
    const asString = selected.sort().join("_");

    if (selected.includes("na")) {
      symbol = pronounComponents()["na"];
    } else {
      symbol = pronounComponents()[asString];
    }

    return symbol;
  };

  const polySymbol = (selected) => {
    let symbol = null;
    if (selected[0] === "grey") {
      symbol = pronounComponents()[selected];
    }

    return symbol;
  };

  // Rendering the flag using SVG
  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <div className="flag-container" border="2px solid black">
        <svg
          id={"flag"}
          className="flag"
          viewBox={`0 0 ${width} ${height}`}
          // Specifying the XML namespace for SVG
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Including horizontal and vertical stripes */}

          <svg
            id="hStripes"
            viewBox={`0 0 600 600`}
            height={height * 25}
            width={width * 25}
            x={-200}
            y={0}
          >
            {hStripes}
          </svg>

          <svg
            id="vStripes"
            viewBox={`0 0 600 600`}
            height={height * 25}
            width={width * 25}
            x={-200}
            y={0}
          >
            {vStripes}
          </svg>
          {/* Adding an optional pentagon element to the flag */}
          <svg
            id="pentagonunderneath"
            viewBox={`0 0 600 600`}
            height={height * 25}
            width={width * 25}
            x={-200}
            y={0}
          >
            {triangle && chevron != "white" && pentagonUnderneath}
          </svg>
          {/* Adding an optional triangle element to the flag */}

          <svg
            id="chevron"
            viewBox={`0 0 600 600`}
            height={height * 25}
            width={width * 25}
            x={-200}
            y={0}
          >
            {chevron && chevron != "white" && leftChevron(chevron)}
          </svg>
          <svg
            id="triangleunderneath"
            viewBox={`0 0 600 600`}
            height={height * 25}
            width={width * 25}
            x={-200}
            y={0}
          >
            {triangle && triangleUnderneath}
          </svg>

          <svg
            id="triangle"
            viewBox={`0 0 600 600`}
            height={height * 25}
            width={width * 25}
            x={-200}
            y={0}
          >
            {triangle && leftTriangle}
          </svg>
          <svg
            viewBox={`0 0 600 600`}
            height={height * 2.1}
            width={width / 1}
            xmlns="http://www.w3.org/2000/svg"
          >
            {pronounSymbol(pronouns)}
          </svg>
          <svg
            viewBox={`0 0 1500 1500`}
            height={94.5}
            width={140}
            x={3}
            y={0}
            xmlns="http://www.w3.org/2000/svg"
          >
            <g transform={`rotate(11.5)`}>{polySymbol(poly)}</g>
          </svg>
        </svg>
      </div>
    </React.Suspense>
  );
};

// Exporting the Flag component as the default export
export default Flag;
